export const ATTENDANCE_LAYOUT = {
  dateColumnWidth: 112,
  employeeColumnWidth: 160,
  summaryColumnWidth: 184,
  tableRowMinHeight: 96,
} as const

export const getAttendanceTableGridColumns = (dateCount: number) => {
  const dateColumns = dateCount > 0 ? `repeat(${dateCount}, minmax(${ATTENDANCE_LAYOUT.dateColumnWidth}px, 1fr)) ` : ""

  return `${ATTENDANCE_LAYOUT.employeeColumnWidth}px ${dateColumns}${ATTENDANCE_LAYOUT.summaryColumnWidth}px`
}

export const getAttendanceTableMinWidth = (dateCount: number) =>
  ATTENDANCE_LAYOUT.employeeColumnWidth +
  dateCount * ATTENDANCE_LAYOUT.dateColumnWidth +
  ATTENDANCE_LAYOUT.summaryColumnWidth
